import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantV2Service } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useEditMerchantInfoMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ data }: { data: any; refetch?: any }) =>
			merchantV2Service.editMerchant(data),
		{
			onSuccess(_data, { refetch }) {
				dispatch(
					uiActions.showSuccessNotification({
						title: "Merchant information has been updated successfully",
					}),
				);
				refetch?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useEditMerchantInfoMutation;
